<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <div class="page-header">
      <button mat-icon-button routerLink="/distributors">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <h2 class="page-title">Editar Distribuidor Exclusivo (DE)</h2>
        <p class="page-subtitle">Altere os dados do distribuidor selecionado</p>
      </div>
    </div>

    <div class="form-section">
      <app-distributor-form
        #distributorForm
        [users]="data.users"
        [productLines]="data.productLines"
        [states]="data.states"
        [accountManagers]="data.accountManagers"
        (accountManagerUpdate)="refreshAccountManager()"
      />
    </div>

    <div class="form-actions">
      <button mat-stroked-button color="primary" routerLink="/distributors">
        <mat-icon>close</mat-icon><span>Cancelar</span>
      </button>
      <button mat-flat-button color="primary" class="mic-btn-icon-left" [disabled]="distributorForm.form?.invalid" (click)="submitForm()">
        <mat-icon>check</mat-icon><span>Confirmar</span>
      </button>
    </div>
  </div>
</mic-spinner-overlay>